export default __webpack_public_path__ + "static/media/bg-polisport-plastics.cb24c599.png";